export default __webpack_public_path__ + "static/media/profile1.ed1cb5bd.png";